export { BOX_SHADOWS, COLORS, FONTS } from './styles';

export const LEGAL = {
  TERMS: 'https://www.iubenda.com/terms-and-conditions/52065115',
  PRIVACY: 'https://www.iubenda.com/privacy-policy/52065115/full-legal'
};

export const LINKS = {
  HELP: 'https://help.pod.link/',
  TWITTER: 'http://twitter.com/_podlink',
};

export const VALIDATORS = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
  SLUG: /^[a-z0-9_](-*?[a-z0-9_])*$/,
};
